import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { ServerConnectionService } from './server-connection.service';
import { regla } from '../models/regla';
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class ReglasService {

  private deleteRegla: regla;

  constructor(private http: HttpClientService) { }

  public getAll() {
    return this.http.get('/reglas/getall');
  }

  public getPendingByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/reglas/getpendingbyidproyecto', params);
  }

  public getByIdRegla(idRegla: number) {
      let params = new HttpParams().set("idRegla", idRegla.toString());
      return this.http.getWithParams('/reglas/getbyidregla', params);
  }

  public new(regla: regla) {
    return this.http.post('/reglas/new', regla);
  }

  public newPeriodic(reglas: regla[]) {
    return this.http.post('/reglas/newperiodic', reglas);
  }

  public deleteSimple(idRegla: number) {
    return this.http.delete('/reglas/delete/' + idRegla);
  }

  public setDeleteRegla(regla: regla) {
    this.deleteRegla = regla;
  }

  public getDeleteRegla() {
    return this.deleteRegla;
  }

}
